import "./Services.css";

import React from "react";

export default function Services() {
  return (
    <section className="section" id="services">
      <div className="section-header">
        <div className="section-heading">My Services</div>
        <div className="section-about">My Provided Features</div>
      </div>
      <div className="section-content">
        <div className="services-row">
          <div className="services-card">
            <div className="services-card-content-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="109"
                height="108"
                viewBox="0 0 109 108"
              >
                <g
                  id="Group_258"
                  data-name="Group 258"
                  transform="translate(-257 -2493)"
                >
                  <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M43.214,0H4.677A4.682,4.682,0,0,0,0,4.677V33.3a4.682,4.682,0,0,0,4.677,4.677H19.269v4.3h-.935a4.678,4.678,0,0,0-4.677,4.677.935.935,0,0,0,.935.935H33.3a.935.935,0,0,0,.935-.935,4.682,4.682,0,0,0-4.677-4.677h-.935v-4.3H43.214A4.682,4.682,0,0,0,47.891,33.3V4.677A4.682,4.682,0,0,0,43.214,0ZM4.677,1.871H43.214a2.809,2.809,0,0,1,2.806,2.806V28.623h-4.3V7.109a.935.935,0,0,0-.935-.935H33.3a.935.935,0,0,0-.935.935V28.623H27.682c-.01-.968-.035-1.921-.075-2.846a60.165,60.165,0,0,0-.731-7.484,4.677,4.677,0,0,0,1.277-6.1L24.911,6.576a.935.935,0,0,0-1.62,0l-3.243,5.616a4.676,4.676,0,0,0,1.029,5.9,59.377,59.377,0,0,0-.788,7.68c-.042.935-.069,1.889-.079,2.848H15.527V14.592a.93.93,0,0,0-.092-.4s0-.01-.006-.015L11.687,6.691a.936.936,0,0,0-1.673,0L6.272,14.174l-.006.015a.93.93,0,0,0-.093.4V28.623h-4.3V4.677A2.809,2.809,0,0,1,4.677,1.871ZM34.235,28.623V8.044h5.612V9.915h-.935a.935.935,0,0,0,0,1.871h.935v2.806h-.935a.935.935,0,0,0,0,1.871h.935v2.806h-.935a.935.935,0,0,0,0,1.871h.935v3.742h-.935a.935.935,0,0,0,0,1.871h.935v1.871ZM24.1,19.2a4.684,4.684,0,0,0,1.009-.112c.174,1.113.429,3.081.579,5.789H22.208c.158-2.706.425-4.705.61-5.856A4.683,4.683,0,0,0,24.1,19.2Zm0-1.871a2.81,2.81,0,0,1-2.433-4.206L24.1,8.915l2.432,4.212A2.808,2.808,0,0,1,24.1,17.333Zm-1.979,9.418h3.65c.02.615.033,1.24.04,1.871H22.08c.007-.627.021-1.252.042-1.871ZM11.786,28.623v-13.1h1.871v13.1Zm-3.742,0v-13.1H9.915v13.1Zm.578-14.966L10.85,9.2l2.228,4.456ZM32.2,46.021H15.686a2.812,2.812,0,0,1,2.647-1.871H29.558A2.811,2.811,0,0,1,32.2,46.021Zm-5.452-3.742H21.139v-4.3h5.612Zm16.463-6.173H4.677A2.809,2.809,0,0,1,1.871,33.3V30.493H46.02V33.3A2.809,2.809,0,0,1,43.214,36.106Zm0,0"
                    transform="translate(287.802 2523.125)"
                    fill="currentColor"
                  />
                  <g
                    id="Ellipse_27"
                    data-name="Ellipse 27"
                    transform="translate(257 2493)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <ellipse
                      cx="54.5"
                      cy="54"
                      rx="54.5"
                      ry="54"
                      stroke="none"
                    />
                    <ellipse cx="54.5" cy="54" rx="53.5" ry="53" fill="none" />
                  </g>
                </g>
              </svg>
            </div>
            <div className="services-card-content-heading">Web Design</div>
            <div className="services-card-content-pattren">
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
            </div>
            <div className="services-card-content-detail">
              Web design refers to the design of websites that are displayed on
              the internet. It usually refers to the user experience aspects of
              website development rather than software development. ... A web
              designer works on the appearance, layout, and, in some cases,
              content of a website.
            </div>
            <a
              href="https://www.google.com/search?q=what+is+Web+Design&sxsrf=AOaemvKGodAHeQpBf8kBPRg7NvqYevw82A%3A1638905069047&ei=7bSvYYGwAv-Oxc8P-fqKmAc&ved=0ahUKEwjB2teTtdL0AhV_R_EDHXm9AnMQ4dUDCA4&uact=5&oq=what+is+Web+Design&gs_lcp=Cgdnd3Mtd2l6EAMyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEdKBAhBGABQmgJYmgJg2wZoAHADeACAAQCIAQCSAQCYAQCgAQKgAQHIAQjAAQE&sclient=gws-wiz"
              title="learn-more"
              className="services-card-content-link"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 14.75 10.372"
              >
                <path
                  id="arrow"
                  d="M9.933,4.83a.523.523,0,0,0-.743.736l3.769,3.769H.52A.518.518,0,0,0,0,9.856a.524.524,0,0,0,.52.528H12.959L9.189,14.146a.534.534,0,0,0,0,.743.521.521,0,0,0,.743,0l4.662-4.662a.512.512,0,0,0,0-.736Z"
                  transform="translate(0 -4.674)"
                />
              </svg>
            </a>
          </div>
          <div className="services-card">
            <div className="services-card-content-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="109"
                height="108"
                viewBox="0 0 109 108"
              >
                <g
                  id="Group_262"
                  data-name="Group 262"
                  transform="translate(-761 -2493)"
                >
                  <g id="Group_261" data-name="Group 261">
                    <g id="Group_260" data-name="Group 260">
                      <g id="Group_259" data-name="Group 259">
                        <g
                          id="Ellipse_27"
                          data-name="Ellipse 27"
                          transform="translate(761 2493)"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <ellipse
                            cx="54.5"
                            cy="54"
                            rx="54.5"
                            ry="54"
                            stroke="none"
                          />
                          <ellipse
                            cx="54.5"
                            cy="54"
                            rx="53.5"
                            ry="53"
                            fill="none"
                          />
                        </g>
                        <g id="Page-1" transform="translate(788.232 2519.13)">
                          <g
                            id="_035---Creative-Thinking"
                            data-name="035---Creative-Thinking"
                            transform="translate(0 0)"
                          >
                            <path
                              id="Shape"
                              d="M47.7,40.538a12.381,12.381,0,0,0-.022-4.7l4.22-10.183a.15.15,0,0,0,0-.02,17.3,17.3,0,0,1,2.962-5.143,1.374,1.374,0,0,0,.34-1.258l-1.73-7.472a.9.9,0,0,0-.092-.223c-.007-.014-.01-.03-.018-.043s-.04-.044-.058-.068a.929.929,0,0,0-.13-.152.856.856,0,0,0-.1-.061.939.939,0,0,0-.143-.087.91.91,0,0,0-.216-.053c-.021,0-.04-.014-.061-.016a.921.921,0,0,0-.508.113c-.014.007-.03.01-.044.018h-.009l-6.505,4.06a1.375,1.375,0,0,0-.65,1.133,17.294,17.294,0,0,1-1.549,5.743v.01l-2.109,5.1a12.359,12.359,0,0,0-3.291-1.188,49.777,49.777,0,0,0,.477-9.059,10.055,10.055,0,0,0,2.287-7.382C40.17,4.238,35.318.36,35.11.2a.921.921,0,0,0-1.46.961c.474,1.782.064,3.662-3.441,7.529a5.392,5.392,0,0,0-1.263,5.875,7.152,7.152,0,0,0,1.312,2.119c-.223,1.423-.4,2.771-.519,4.084a46.139,46.139,0,0,0-.16,6.534,12.536,12.536,0,0,0-2.294,1.6L22.816,9.79c0-.019-.018-.033-.024-.051a.871.871,0,0,0-.064-.178L18.164,1.132a2.127,2.127,0,0,0-4,.936l-.346,9.577a.952.952,0,0,0,.023.205v.041L18.4,31.348a10.375,10.375,0,0,0-2.13.318L11.258,19.555a1.862,1.862,0,0,0-2.4-.985L1.189,21.743a1.848,1.848,0,0,0-1,2.407l6.8,16.407a7.366,7.366,0,0,0,.38,14.722H47.909A7.371,7.371,0,1,0,47.7,40.538ZM46.757,16.69l3.862-2.41-1.367,3.3a.922.922,0,1,0,1.7.706l1.367-3.3,1.024,4.434a18.222,18.222,0,0,0-2.672,4.41,3.789,3.789,0,0,1-5.15-2.13A18.2,18.2,0,0,0,46.757,16.69Zm-2.119,7.233a5.612,5.612,0,0,0,2.3,1.672,5.847,5.847,0,0,0,2.254.475,4.875,4.875,0,0,0,.558-.034l-2.94,7.094a12.5,12.5,0,0,0-3.956-4.891Zm-12.622-6.58,4.629.283c.029.861.018,1.75-.01,2.654a19.367,19.367,0,0,1-4.616-.223c-.116-.017-.229-.029-.345-.045.092-.868.2-1.747.34-2.669Zm-.439-7.419c2.446-2.7,3.714-4.774,4.009-6.726A12.322,12.322,0,0,1,38.91,9.8a8.255,8.255,0,0,1-1.865,6q-2.73-.166-5.4-.332a3.843,3.843,0,0,1-.071-5.546Zm-.07,11.925.267.035a26.244,26.244,0,0,0,3.587.3c.381,0,.783-.03,1.186-.062-.084,1.186-.221,2.424-.4,3.7-.228-.012-.451-.034-.679-.034a12.339,12.339,0,0,0-4.083.7,44.458,44.458,0,0,1,.116-4.651ZM24.38,32.623,21.744,21.395a.921.921,0,0,0-1.794.42l2.369,10.106a10.435,10.435,0,0,0-2.008-.5L16.267,14.164a4.366,4.366,0,0,0,1.8.392c.058,0,.12-.008.179-.011l.651,2.781a.921.921,0,1,0,1.794-.42l-.652-2.783a4.363,4.363,0,0,0,1.61-1.225l4.111,17.578A12.361,12.361,0,0,0,24.38,32.623ZM18.751,12.63A3.059,3.059,0,0,1,15.674,11.4l.117-3.245a5.422,5.422,0,0,0,.972.092,4.105,4.105,0,0,0,.936-.1,4.693,4.693,0,0,0,1.708-.849l1.551,2.863a3.056,3.056,0,0,1-2.208,2.476ZM16.227,1.867a.287.287,0,0,1,.317.142l1.975,3.653a3.144,3.144,0,0,1-1.244.691,3.132,3.132,0,0,1-1.42-.067l.15-4.151A.286.286,0,0,1,16.227,1.867ZM9.56,20.269l.7,1.7L6.855,23.381a.921.921,0,0,0,.355,1.771.935.935,0,0,0,.353-.07l3.409-1.412.7,1.7-1.705.707a.921.921,0,0,0,.354,1.773.937.937,0,0,0,.352-.07l1.705-.707.7,1.7L9.675,30.191a.921.921,0,0,0,.354,1.773.933.933,0,0,0,.352-.07l3.409-1.411.745,1.8a10.7,10.7,0,0,0-5.965,7.261l-6.678-16.1Zm38.35,33.167H7.371a5.528,5.528,0,1,1,0-11.056,5.427,5.427,0,0,1,1.576.228.921.921,0,0,0,1.188-.865,8.752,8.752,0,0,1,14-6.826.921.921,0,0,0,1.412-.415,10.6,10.6,0,0,1,20.05,6.84.921.921,0,0,0,1.078,1.172,5.752,5.752,0,0,1,1.23-.135,5.528,5.528,0,0,1,0,11.056Z"
                              transform="translate(-0.012 0)"
                              fill="currentColor"
                            />
                            <path
                              id="Shape-2"
                              data-name="Shape"
                              d="M38.607,15.145a.921.921,0,0,0,.737-.364,6.91,6.91,0,0,0,1.225-5.425.921.921,0,1,0-1.78.474,5.118,5.118,0,0,1-.914,3.838.921.921,0,0,0,.737,1.474Z"
                              transform="translate(-2.977 -0.68)"
                              fill="currentColor"
                            />
                            <path
                              id="Shape-3"
                              data-name="Shape"
                              d="M36.348,45.846a4.529,4.529,0,0,0-1.976.461,5.528,5.528,0,0,0-9.549,5.427.921.921,0,0,0,.848.56.911.911,0,0,0,.361-.074.921.921,0,0,0,.486-1.209,3.753,3.753,0,0,1-.3-1.48A3.685,3.685,0,0,1,29.9,45.846a3.648,3.648,0,0,1,3.331,2.119,1,1,0,0,0,.064.087.936.936,0,0,0,.049.092c.017.02.041.029.059.049a1.294,1.294,0,0,0,.29.212.917.917,0,0,0,.166.052.847.847,0,0,0,.173.027,1.132,1.132,0,0,0,.352-.059.7.7,0,0,0,.073-.018.835.835,0,0,0,.086-.064.957.957,0,0,0,.1-.05,2.717,2.717,0,0,1,1.71-.6A2.764,2.764,0,0,1,38.854,49.3a.921.921,0,1,0,1.677-.765A4.607,4.607,0,0,0,36.348,45.846Z"
                              transform="translate(-1.93 -3.465)"
                              fill="currentColor"
                            />
                            <path
                              id="Shape-4"
                              data-name="Shape"
                              d="M17.394,39.047A5,5,0,0,0,14,43.606a.921.921,0,1,0,1.843,0,3.167,3.167,0,0,1,2.139-2.813.923.923,0,0,0-.588-1.75Z"
                              transform="translate(-1.113 -3.068)"
                              fill="currentColor"
                            />
                            <path
                              id="Shape-5"
                              data-name="Shape"
                              d="M31.7,37.5a.9.9,0,0,0,.224.028.921.921,0,0,0,.893-.7,3.93,3.93,0,0,1,3.718-2.988.921.921,0,0,0,0-1.843,5.739,5.739,0,0,0-5.5,4.383A.921.921,0,0,0,31.7,37.5Z"
                              transform="translate(-2.45 -2.518)"
                              fill="currentColor"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div className="services-card-content-heading">Graphics Design</div>
            <div className="services-card-content-pattren">
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
            </div>
            <div className="services-card-content-detail">
              A graphic designer is a professional within the graphic design and
              graphic arts industry who assembles together images, typography,
              or motion graphics to create a piece of design. ... They are also
              sometimes responsible for typesetting, illustration, user
              interfaces, and web design.
            </div>
            <a
              href="https://www.google.com/search?q=what+is+Graphics+Design&sxsrf=AOaemvIM3pGWRk3YRJbw8C6h07RAn5MtDw%3A1638905045961&ei=1bSvYdr-OfyTxc8P-aqcsAs&ved=0ahUKEwiavdaItdL0AhX8SfEDHXkVB7YQ4dUDCA4&uact=5&oq=what+is+Graphics+Design&gs_lcp=Cgdnd3Mtd2l6EAMyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEdKBAhBGABQpgxYpgxgzw9oAHADeACAAQCIAQCSAQCYAQCgAQKgAQHIAQjAAQE&sclient=gws-wiz"
              title="learn-more"
              className="services-card-content-link"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 14.75 10.372"
              >
                <path
                  id="arrow"
                  d="M9.933,4.83a.523.523,0,0,0-.743.736l3.769,3.769H.52A.518.518,0,0,0,0,9.856a.524.524,0,0,0,.52.528H12.959L9.189,14.146a.534.534,0,0,0,0,.743.521.521,0,0,0,.743,0l4.662-4.662a.512.512,0,0,0,0-.736Z"
                  transform="translate(0 -4.674)"
                />
              </svg>
            </a>
          </div>
          <div className="services-card">
            <div className="services-card-content-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="109"
                height="108"
                viewBox="0 0 109 108"
              >
                <g
                  id="Group_263"
                  data-name="Group 263"
                  transform="translate(-1265 -2493)"
                >
                  <g
                    id="Ellipse_27"
                    data-name="Ellipse 27"
                    transform="translate(1265 2493)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <ellipse
                      cx="54.5"
                      cy="54"
                      rx="54.5"
                      ry="54"
                      stroke="none"
                    />
                    <ellipse cx="54.5" cy="54" rx="53.5" ry="53" fill="none" />
                  </g>
                  <g
                    id="_1237114"
                    data-name="1237114"
                    transform="translate(1294.386 2521.684)"
                  >
                    <path
                      id="Path_107"
                      data-name="Path 107"
                      d="M3.348,112.778h12.87l-.837,1.673h-.319c-2.62,0-4.184,1.251-4.184,3.347a1.673,1.673,0,0,0,1.673,1.673h25.1a1.673,1.673,0,0,0,1.673-1.673c0-2.1-1.564-3.347-4.184-3.347h-.319l-.837-1.673h12.87a3.347,3.347,0,0,0,3.347-3.347V80.147A3.347,3.347,0,0,0,46.856,76.8h-9.2a.837.837,0,1,0,0,1.673h9.2a1.673,1.673,0,0,1,1.673,1.673v29.284a1.673,1.673,0,0,1-1.673,1.673H3.348a1.673,1.673,0,0,1-1.673-1.673V80.147a1.673,1.673,0,0,1,1.673-1.673h9.2a.837.837,0,1,0,0-1.673h-9.2A3.347,3.347,0,0,0,0,80.147v29.284a3.347,3.347,0,0,0,3.347,3.347Zm34.3,5.02h-25.1c0-.414,0-1.673,2.51-1.673h20.08c2.51,0,2.51,1.259,2.51,1.673Zm-5.538-5.02.836,1.673h-15.7l.836-1.673Zm0,0"
                      transform="translate(-0.001 -69.27)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_108"
                      data-name="Path 108"
                      d="M75.131,135.2H36.644a.837.837,0,0,1-.837-.836V113.443a.837.837,0,0,1,.837-.837h2.51a.837.837,0,1,0,0-1.673h-2.51a2.51,2.51,0,0,0-2.51,2.51v20.917a2.51,2.51,0,0,0,2.51,2.51H75.131a2.51,2.51,0,0,0,2.51-2.51V113.443a2.51,2.51,0,0,0-2.51-2.51h-2.51a.837.837,0,1,0,0,1.673h2.51a.837.837,0,0,1,.837.837v20.917A.837.837,0,0,1,75.131,135.2Zm0,0"
                      transform="translate(-30.787 -100.056)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_109"
                      data-name="Path 109"
                      d="M205.637,392.535a.837.837,0,0,0,0,1.673H214a.837.837,0,0,0,0-1.673Zm0,0"
                      transform="translate(-184.72 -354.047)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_110"
                      data-name="Path 110"
                      d="M135.914,4.864l-1.4-1.4a1.673,1.673,0,0,0-2.114-.2l-2.092,1.381a10.325,10.325,0,0,0-2.036-.83l-.493-2.467A1.673,1.673,0,0,0,126.145,0H124.17a1.673,1.673,0,0,0-1.641,1.345l-.506,2.463a10.325,10.325,0,0,0-2.029.845l-2.083-1.39a1.673,1.673,0,0,0-2.113.207l-1.4,1.4a1.679,1.679,0,0,0-.2,2.11l1.382,2.092a10.414,10.414,0,0,0-.83,2.036l-2.467.492a1.68,1.68,0,0,0-1.349,1.64v1.976a1.678,1.678,0,0,0,1.346,1.641l2.462.5a10.432,10.432,0,0,0,.844,2.029L114.2,21.471a1.679,1.679,0,0,0,.208,2.114l1.4,1.4a1.673,1.673,0,0,0,2.113.208l2.092-1.381a10.348,10.348,0,0,0,2.036.83l.493,2.467a1.674,1.674,0,0,0,1.636,1.344h1.975a1.673,1.673,0,0,0,1.641-1.344l.506-2.464a10.3,10.3,0,0,0,2.029-.845l2.083,1.393a1.673,1.673,0,0,0,2.115-.208l1.4-1.4a1.68,1.68,0,0,0,.207-2.114l-1.382-2.092a10.827,10.827,0,0,0,.837-2.022l-.8-.238.8.225,2.467-.492a1.679,1.679,0,0,0,1.341-1.64V13.236a1.678,1.678,0,0,0-1.346-1.641l-2.462-.5a10.425,10.425,0,0,0-.844-2.029l1.393-2.084a1.672,1.672,0,0,0-.208-2.116Zm-2.577,3.268a1.68,1.68,0,0,0-.072,1.726,9.093,9.093,0,0,1,.7,1.709,1.673,1.673,0,0,0,1.273,1.176l2.465.493v1.976l-2.465.493a1.673,1.673,0,0,0-1.273,1.176,9.125,9.125,0,0,1-.7,1.709,1.674,1.674,0,0,0,.073,1.726l1.393,2.084-1.4,1.4L131.25,22.4a1.681,1.681,0,0,0-1.727-.074,9.1,9.1,0,0,1-1.709.705,1.676,1.676,0,0,0-1.171,1.272l-.5,2.466H124.17l-.494-2.467a1.679,1.679,0,0,0-1.177-1.273,9.083,9.083,0,0,1-1.708-.7,1.71,1.71,0,0,0-.809-.2,1.649,1.649,0,0,0-.92.278L116.978,23.8l-1.4-1.4,1.394-2.085a1.679,1.679,0,0,0,.072-1.726,9.094,9.094,0,0,1-.7-1.709,1.673,1.673,0,0,0-1.273-1.176l-2.462-.493V13.236l2.465-.493a1.673,1.673,0,0,0,1.273-1.176,9.138,9.138,0,0,1,.7-1.709,1.673,1.673,0,0,0-.073-1.726l-1.393-2.084,1.4-1.4,2.084,1.393a1.674,1.674,0,0,0,1.727.074,9.077,9.077,0,0,1,1.709-.705,1.677,1.677,0,0,0,1.175-1.273l.494-2.466h1.975l.494,2.467a1.679,1.679,0,0,0,1.177,1.273,9.083,9.083,0,0,1,1.708.7,1.673,1.673,0,0,0,1.727-.073l2.084-1.393,1.4,1.4Zm0,0"
                      transform="translate(-100.056 0)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_111"
                      data-name="Path 111"
                      d="M194.428,76.8a6.693,6.693,0,1,0,6.693,6.693A6.693,6.693,0,0,0,194.428,76.8Zm0,11.714a5.02,5.02,0,1,1,5.02-5.02A5.02,5.02,0,0,1,194.428,88.514Zm0,0"
                      transform="translate(-169.327 -69.27)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_112"
                      data-name="Path 112"
                      d="M249.138,137.371a.837.837,0,1,1-.837-.836A.837.837,0,0,1,249.138,137.371Zm0,0"
                      transform="translate(-223.201 -123.147)"
                      fill="currentColor"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div className="services-card-content-heading">Web Development</div>
            <div className="services-card-content-pattren">
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
            </div>
            <div className="services-card-content-detail">
              Web development is the work involved in developing a website for
              the Internet (World Wide Web) or an intranet (a private network).
              ... Among Web professionals, "Web development" usually refers to
              the main non-design aspects of building Web sites: writing markup
              and coding.
            </div>
            <a
              href="https://www.google.com/search?q=what+is+Web+Development&sxsrf=AOaemvKDMJJmIkA6Oh7q5c98J35Y6hzbVQ%3A1638905036942&ei=zLSvYbjmM8-Hxc8PmKy04AY&ved=0ahUKEwi4_KqEtdL0AhXPQ_EDHRgWDWwQ4dUDCA4&uact=5&oq=what+is+Web+Development&gs_lcp=Cgdnd3Mtd2l6EAMyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEdKBAhBGABQ-RJYph9gpyFoAHADeACAAQCIAQCSAQCYAQCgAQHIAQjAAQE&sclient=gws-wiz"
              title="learn-more"
              className="services-card-content-link"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 14.75 10.372"
              >
                <path
                  id="arrow"
                  d="M9.933,4.83a.523.523,0,0,0-.743.736l3.769,3.769H.52A.518.518,0,0,0,0,9.856a.524.524,0,0,0,.52.528H12.959L9.189,14.146a.534.534,0,0,0,0,.743.521.521,0,0,0,.743,0l4.662-4.662a.512.512,0,0,0,0-.736Z"
                  transform="translate(0 -4.674)"
                />
              </svg>
            </a>
          </div>
          <div className="services-card">
            <div className="services-card-content-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="109"
                height="108"
                viewBox="0 0 109 108"
              >
                <g
                  id="Group_264"
                  data-name="Group 264"
                  transform="translate(-257 -3069)"
                >
                  <g
                    id="Ellipse_27"
                    data-name="Ellipse 27"
                    transform="translate(257 3069)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <ellipse
                      cx="54.5"
                      cy="54"
                      rx="54.5"
                      ry="54"
                      stroke="none"
                    />
                    <ellipse cx="54.5" cy="54" rx="53.5" ry="53" fill="none" />
                  </g>
                  <g
                    id="Group_151"
                    data-name="Group 151"
                    transform="translate(282 3094)"
                  >
                    <g id="Group_150" data-name="Group 150">
                      <path
                        id="Path_74"
                        data-name="Path 74"
                        d="M55.432,8.533H3.96A3.965,3.965,0,0,0,0,12.493V45.158a.99.99,0,0,0,.99.99H58.4a.99.99,0,0,0,.99-.99V12.493A3.965,3.965,0,0,0,55.432,8.533Zm1.981,35.635H1.98V12.493A1.983,1.983,0,0,1,3.96,10.513H55.432a1.983,1.983,0,0,1,1.981,1.981Z"
                        transform="translate(0 -8.533)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_153"
                    data-name="Group 153"
                    transform="translate(282 3129.635)"
                  >
                    <g id="Group_152" data-name="Group 152">
                      <path
                        id="Path_75"
                        data-name="Path 75"
                        d="M58.4,315.733H.99a.99.99,0,0,0-.99.99v4.948a3.965,3.965,0,0,0,3.96,3.96H55.432a3.965,3.965,0,0,0,3.96-3.96v-4.948A.99.99,0,0,0,58.4,315.733Zm-.99,5.938a1.983,1.983,0,0,1-1.981,1.981H3.96a1.983,1.983,0,0,1-1.981-1.981v-3.959H57.413v3.959Z"
                        transform="translate(0 -315.733)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_155"
                    data-name="Group 155"
                    transform="translate(307.737 3133.595)"
                  >
                    <g id="Group_154" data-name="Group 154">
                      <path
                        id="Path_76"
                        data-name="Path 76"
                        d="M228.8,349.867h-5.939a.99.99,0,1,0,0,1.98H228.8a.99.99,0,1,0,0-1.98Z"
                        transform="translate(-221.867 -349.867)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_157"
                    data-name="Group 157"
                    transform="translate(285.959 3097.96)"
                  >
                    <g id="Group_156" data-name="Group 156">
                      <path
                        id="Path_77"
                        data-name="Path 77"
                        d="M84.617,42.667H35.124a.99.99,0,0,0-.99.99V75.333a.99.99,0,0,0,.99.99H84.617a.99.99,0,0,0,.99-.99V43.657A.99.99,0,0,0,84.617,42.667Zm-.99,31.676H36.114v-29.7H83.627Z"
                        transform="translate(-34.134 -42.667)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_159"
                    data-name="Group 159"
                    transform="translate(295.858 3145.473)"
                  >
                    <g id="Group_158" data-name="Group 158">
                      <path
                        id="Path_78"
                        data-name="Path 78"
                        d="M148.173,452.267H122.437a2.97,2.97,0,1,0,0,5.939h25.737a2.97,2.97,0,1,0,0-5.939Zm0,3.959H122.437a.99.99,0,0,1,0-1.98h25.737a.99.99,0,1,1,0,1.98Z"
                        transform="translate(-119.467 -452.267)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_161"
                    data-name="Group 161"
                    transform="translate(299.818 3137.554)"
                  >
                    <g id="Group_160" data-name="Group 160">
                      <path
                        id="Path_79"
                        data-name="Path 79"
                        d="M176.368,391.92c-3.284,0-4.949-2.331-4.949-6.929a.99.99,0,0,0-.99-.99h-9.9a.99.99,0,0,0-.99.99c0,4.6-1.665,6.929-4.949,6.929a.99.99,0,0,0,0,1.98h21.777a.99.99,0,0,0,0-1.98Zm-16.956,0a9.483,9.483,0,0,0,2.081-5.939h7.973a9.472,9.472,0,0,0,2.081,5.939Z"
                        transform="translate(-153.601 -384.001)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_163"
                    data-name="Group 163"
                    transform="translate(316.652 3114.787)"
                  >
                    <g id="Group_162" data-name="Group 162">
                      <path
                        id="Path_80"
                        data-name="Path 80"
                        d="M311.371,196.11l-2.389-2.389,1.329-1.329a.99.99,0,0,0-.415-1.648l-9.9-2.97a.99.99,0,0,0-1.232,1.232l2.97,9.9a.989.989,0,0,0,1.648.416l1.4-1.4,2.389,2.391a.989.989,0,0,0,1.4,0l2.8-2.8A.989.989,0,0,0,311.371,196.11Zm-3.5,2.1-2.176-2.177a1.294,1.294,0,0,0-1.827,0l-.715.715-1.965-6.55,6.55,1.965-.766.766a1.122,1.122,0,0,0,0,1.585l2.3,2.3Z"
                        transform="translate(-298.723 -187.731)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_165"
                    data-name="Group 165"
                    transform="translate(294.868 3101.919)"
                  >
                    <g id="Group_164" data-name="Group 164">
                      <path
                        id="Path_81"
                        data-name="Path 81"
                        d="M139.64,76.8H111.924a.99.99,0,0,0-.99.99v4.949a.99.99,0,0,0,.99.99H139.64a.99.99,0,0,0,.99-.99V77.79A.99.99,0,0,0,139.64,76.8Zm-.99,4.949H112.914V78.78H138.65Z"
                        transform="translate(-110.934 -76.8)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_167"
                    data-name="Group 167"
                    transform="translate(298.828 3112.808)"
                  >
                    <g id="Group_166" data-name="Group 166">
                      <path
                        id="Path_82"
                        data-name="Path 82"
                        d="M153.976,170.667h-7.919a.99.99,0,0,0-.99.99v3.959a.99.99,0,0,0,.99.99h7.919a.99.99,0,0,0,.99-.99v-3.959A.99.99,0,0,0,153.976,170.667Zm-.99,3.959h-5.939v-1.98h5.939Z"
                        transform="translate(-145.067 -170.667)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_169"
                    data-name="Group 169"
                    transform="translate(294.868 3101.919)"
                  >
                    <g id="Group_168" data-name="Group 168">
                      <path
                        id="Path_83"
                        data-name="Path 83"
                        d="M139.64,76.8H111.924a.99.99,0,0,0-.99.99V96.6a.99.99,0,0,0,.99.99h23.565a.991.991,0,0,0,.948-1.275l-1.253-4.178,4.172,1.252a.99.99,0,0,0,1.274-.948V77.79A.99.99,0,0,0,139.64,76.8Zm-.99,14.308-4.659-1.4a.99.99,0,0,0-1.232,1.233l1.4,4.664H112.914V78.78H138.65Z"
                        transform="translate(-110.934 -76.8)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div className="services-card-content-heading">
              Application Development
            </div>
            <div className="services-card-content-pattren">
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
            </div>
            <div className="services-card-content-detail">
              Application development is the process of creating a computer
              program or a set of programs to perform the different tasks that a
              business requires. ... Every app-building process follows the same
              steps: gathering requirements, designing prototypes, testing,
              implementation, and integration.
            </div>
            <a
              href="https://www.google.com/search?q=Application+Development&btnK=Google+Search&sxsrf=AOaemvL2Z2gA2lkZaqBouMLtxIzvqbZivA%3A1638905000143&source=hp&ei=qLSvYfrEBv-QseMPvIqh2Ac&iflsig=ALs-wAMAAAAAYa_CuO1WDhFryi0jtBD4Re2ZQ8SoifAR"
              title="learn-more"
              className="services-card-content-link"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 14.75 10.372"
              >
                <path
                  id="arrow"
                  d="M9.933,4.83a.523.523,0,0,0-.743.736l3.769,3.769H.52A.518.518,0,0,0,0,9.856a.524.524,0,0,0,.52.528H12.959L9.189,14.146a.534.534,0,0,0,0,.743.521.521,0,0,0,.743,0l4.662-4.662a.512.512,0,0,0,0-.736Z"
                  transform="translate(0 -4.674)"
                />
              </svg>
            </a>
          </div>
          <div className="services-card">
            <div className="services-card-content-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="109"
                height="108"
                viewBox="0 0 109 108"
              >
                <g
                  id="Group_265"
                  data-name="Group 265"
                  transform="translate(-761 -3069)"
                >
                  <g
                    id="Ellipse_27"
                    data-name="Ellipse 27"
                    transform="translate(761 3069)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <ellipse
                      cx="54.5"
                      cy="54"
                      rx="54.5"
                      ry="54"
                      stroke="none"
                    />
                    <ellipse cx="54.5" cy="54" rx="53.5" ry="53" fill="none" />
                  </g>
                  <g
                    id="Group_171"
                    data-name="Group 171"
                    transform="translate(783.398 3094.398)"
                  >
                    <g
                      id="Group_170"
                      data-name="Group 170"
                      transform="translate(0)"
                    >
                      <path
                        id="Path_84"
                        data-name="Path 84"
                        d="M49.9,0H4.047A4.046,4.046,0,0,0,0,4.046V36.415a4.046,4.046,0,0,0,4.046,4.046H21.58v-2.7H4.047A1.349,1.349,0,0,1,2.7,36.415V4.046A1.349,1.349,0,0,1,4.047,2.7H49.9a1.349,1.349,0,0,1,1.349,1.349V28.322h2.7V4.046A4.046,4.046,0,0,0,49.9,0Z"
                        transform="translate(-0.001)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_173"
                    data-name="Group 173"
                    transform="translate(799.583 3133.51)"
                  >
                    <g id="Group_172" data-name="Group 172">
                      <rect
                        id="Rectangle_117"
                        data-name="Rectangle 117"
                        width="2.697"
                        height="8.092"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_175"
                    data-name="Group 175"
                    transform="translate(788.793 3122.721)"
                  >
                    <g id="Group_174" data-name="Group 174">
                      <path
                        id="Path_85"
                        data-name="Path 85"
                        d="M46.714,228.046a1.349,1.349,0,0,1-1.349-1.349V224h-2.7v2.7a4.046,4.046,0,0,0,4.046,4.046h2.7v-2.7Z"
                        transform="translate(-42.668 -224)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_177"
                    data-name="Group 177"
                    transform="translate(788.793 3117.326)"
                  >
                    <g id="Group_176" data-name="Group 176">
                      <rect
                        id="Rectangle_118"
                        data-name="Rectangle 118"
                        width="2.697"
                        height="2.697"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_179"
                    data-name="Group 179"
                    transform="translate(807.673 3118.673)"
                  >
                    <g id="Group_178" data-name="Group 178">
                      <path
                        id="Path_86"
                        data-name="Path 86"
                        d="M217,196.282A14.653,14.653,0,1,0,217,217,14.653,14.653,0,0,0,217,196.282ZM206.632,218.6a11.956,11.956,0,1,1,11.96-11.952A11.956,11.956,0,0,1,206.632,218.6Z"
                        transform="translate(-191.986 -191.989)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_181"
                    data-name="Group 181"
                    transform="translate(833.21 3144.208)"
                  >
                    <g id="Group_180" data-name="Group 180">
                      <path
                        id="Path_87"
                        data-name="Path 87"
                        d="M408.486,402.8l-8.466-8.463a1.348,1.348,0,0,0-1.907,0l-3.763,3.763a1.349,1.349,0,0,0,0,1.907l8.466,8.467a1.348,1.348,0,0,0,.953.4h0a1.348,1.348,0,0,0,.953-.4l3.763-3.763A1.349,1.349,0,0,0,408.486,402.8Zm-4.716,2.813-6.559-6.56,1.856-1.856,6.559,6.56Z"
                        transform="translate(-393.956 -393.942)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_183"
                    data-name="Group 183"
                    transform="translate(830.782 3141.781)"
                  >
                    <g
                      id="Group_182"
                      data-name="Group 182"
                      transform="translate(0 0)"
                    >
                      <rect
                        id="Rectangle_119"
                        data-name="Rectangle 119"
                        width="2.697"
                        height="6.652"
                        transform="translate(0 1.907) rotate(-45)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_185"
                    data-name="Group 185"
                    transform="translate(822.51 3124.07)"
                  >
                    <g id="Group_184" data-name="Group 184">
                      <path
                        id="Path_88"
                        data-name="Path 88"
                        d="M309.334,234.667v2.7a6.752,6.752,0,0,1,6.743,6.743h2.7A9.451,9.451,0,0,0,309.334,234.667Z"
                        transform="translate(-309.334 -234.667)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_187"
                    data-name="Group 187"
                    transform="translate(796.885 3140.254)"
                  >
                    <g id="Group_186" data-name="Group 186">
                      <rect
                        id="Rectangle_120"
                        data-name="Rectangle 120"
                        width="10.789"
                        height="2.697"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_189"
                    data-name="Group 189"
                    transform="translate(799.583 3099.793)"
                  >
                    <g id="Group_188" data-name="Group 188">
                      <path
                        id="Path_89"
                        data-name="Path 89"
                        d="M132.047,42.667a4.046,4.046,0,1,0,4.046,4.046A4.046,4.046,0,0,0,132.047,42.667Zm0,5.395a1.349,1.349,0,1,1,1.349-1.349A1.349,1.349,0,0,1,132.047,48.062Z"
                        transform="translate(-128.001 -42.667)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_191"
                    data-name="Group 191"
                    transform="translate(809.023 3109.234)"
                  >
                    <g id="Group_190" data-name="Group 190">
                      <path
                        id="Path_90"
                        data-name="Path 90"
                        d="M206.714,117.333a4.046,4.046,0,1,0,4.046,4.046A4.046,4.046,0,0,0,206.714,117.333Zm0,5.395a1.349,1.349,0,1,1,1.349-1.349A1.349,1.349,0,0,1,206.714,122.728Z"
                        transform="translate(-202.668 -117.333)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_193"
                    data-name="Group 193"
                    transform="translate(794.583 3104.235)"
                  >
                    <g
                      id="Group_192"
                      data-name="Group 192"
                      transform="translate(0 0)"
                    >
                      <rect
                        id="Rectangle_121"
                        data-name="Rectangle 121"
                        width="9.537"
                        height="2.697"
                        transform="translate(0 6.743) rotate(-45)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_195"
                    data-name="Group 195"
                    transform="translate(804.018 3104.238)"
                  >
                    <g
                      id="Group_194"
                      data-name="Group 194"
                      transform="translate(0 0)"
                    >
                      <rect
                        id="Rectangle_122"
                        data-name="Rectangle 122"
                        width="2.697"
                        height="9.537"
                        transform="translate(0 1.907) rotate(-45)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_197"
                    data-name="Group 197"
                    transform="translate(818.464 3099.793)"
                  >
                    <g id="Group_196" data-name="Group 196">
                      <path
                        id="Path_91"
                        data-name="Path 91"
                        d="M281.38,42.667a4.046,4.046,0,1,0,4.046,4.046A4.046,4.046,0,0,0,281.38,42.667Zm0,5.395a1.349,1.349,0,1,1,1.349-1.349A1.349,1.349,0,0,1,281.38,48.062Z"
                        transform="translate(-277.334 -42.667)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_199"
                    data-name="Group 199"
                    transform="translate(813.464 3104.24)"
                  >
                    <g
                      id="Group_198"
                      data-name="Group 198"
                      transform="translate(0 0)"
                    >
                      <rect
                        id="Rectangle_123"
                        data-name="Rectangle 123"
                        width="9.537"
                        height="2.697"
                        transform="translate(0 6.743) rotate(-45)"
                        fill="currentColor"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div className="services-card-content-heading">
              Testing & Analytics
            </div>
            <div className="services-card-content-pattren">
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
            </div>
            <div className="services-card-content-detail">
              Test analytics is a web-based tool that shows test trends. ... To
              display the test trends, test analytics shows previous test
              results for comparison. Not only that, you can also get error
              rate, pass/fail ratio, and certain other parameters using this
              tool. Also, multiple users can work on this tool at the same time.
            </div>
            <a
              href="https://www.google.com/search?q=what+isTesting+%26+Analytics&sxsrf=AOaemvIAhP_gHtvdhRHgLEDxt2vraPCcmw%3A1638905091177&ei=A7WvYbaiCvKIxc8P8veo2A0&ved=0ahUKEwj2r56etdL0AhVyRPEDHfI7CtsQ4dUDCA4&uact=5&oq=what+isTesting+%26+Analytics&gs_lcp=Cgdnd3Mtd2l6EAMyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEdKBAhBGABQ1wFY1wFg-wZoAHADeACAAQCIAQCSAQCYAQCgAQKgAQHIAQjAAQE&sclient=gws-wiz"
              title="learn-more"
              className="services-card-content-link"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 14.75 10.372"
              >
                <path
                  id="arrow"
                  d="M9.933,4.83a.523.523,0,0,0-.743.736l3.769,3.769H.52A.518.518,0,0,0,0,9.856a.524.524,0,0,0,.52.528H12.959L9.189,14.146a.534.534,0,0,0,0,.743.521.521,0,0,0,.743,0l4.662-4.662a.512.512,0,0,0,0-.736Z"
                  transform="translate(0 -4.674)"
                />
              </svg>
            </a>
          </div>
          <div className="services-card">
            <div className="services-card-content-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="109"
                height="108"
                viewBox="0 0 109 108"
              >
                <g
                  id="Group_266"
                  data-name="Group 266"
                  transform="translate(-1265 -3069)"
                >
                  <g
                    id="Ellipse_27"
                    data-name="Ellipse 27"
                    transform="translate(1265 3069)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <ellipse
                      cx="54.5"
                      cy="54"
                      rx="54.5"
                      ry="54"
                      stroke="none"
                    />
                    <ellipse cx="54.5" cy="54" rx="53.5" ry="53" fill="none" />
                  </g>
                  <g id="probl" transform="translate(1286.354 3089.403)">
                    <path
                      id="Path_92"
                      data-name="Path 92"
                      d="M110.685,89.446a1.106,1.106,0,0,0,1.106,1.106h8.845a1.106,1.106,0,0,0,1.106-1.106V80.6a5.528,5.528,0,0,0-4.1-5.319,6.634,6.634,0,1,0-9.481,0,5.528,5.528,0,0,0-4.1,5.319v3.8a1.106,1.106,0,1,0,2.211,0V80.6a3.317,3.317,0,0,1,3.317-3.317h6.634A3.317,3.317,0,0,1,119.53,80.6v7.739H111.79a1.106,1.106,0,0,0-1.106,1.106ZM112.9,66.228a4.422,4.422,0,1,1-4.422,4.422A4.422,4.422,0,0,1,112.9,66.228Zm0,0"
                      transform="translate(-89.638 -55.172)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_93"
                      data-name="Path 93"
                      d="M171.368,186.281a1.106,1.106,0,1,0,0-2.211h-2.211a1.106,1.106,0,1,0,0,2.211Zm0,0"
                      transform="translate(-144.793 -158.64)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_94"
                      data-name="Path 94"
                      d="M65.406,55.985,52.115,42.694a3.4,3.4,0,0,0-3.759-.628l-5.86-5.86A23.218,23.218,0,1,0,8.5,41.135a1.106,1.106,0,0,0,1.406-1.707A21.031,21.031,0,1,1,40,35.855c-.265.351-.535.7-.822,1.03-.024.03-.052.057-.077.086a20.96,20.96,0,0,1-2.077,2.077c-.035.03-.066.063-.1.093q-.5.424-1.017.811a20.876,20.876,0,0,1-12.647,4.273c-.35,0-.7-.018-1.045-.036a1.107,1.107,0,1,0-.121,2.211c.388.021.774.039,1.166.039a23.087,23.087,0,0,0,12.985-3.98l6.491,6.491a1.105,1.105,0,0,0,1.563,0l4.691-4.691a1.135,1.135,0,0,1,1.564,0l13.29,13.292a1.105,1.105,0,0,1,0,1.562L59.153,63.8a1.105,1.105,0,0,1-1.564,0l-8.71-8.71a1.106,1.106,0,0,0-1.563,1.563l8.71,8.71a3.317,3.317,0,0,0,4.691,0l4.69-4.69a3.316,3.316,0,0,0,0-4.691ZM41.157,37.991l5.485,5.485L43.516,46.6,38.03,41.117A23.414,23.414,0,0,0,41.157,37.991Zm0,0"
                      transform="translate(0 0)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_95"
                      data-name="Path 95"
                      d="M161.157,150.181a1.106,1.106,0,0,0,0,2.211A18.735,18.735,0,0,0,179.338,128.9a1.106,1.106,0,0,0-2.142.553,16.521,16.521,0,0,1-16.04,20.73Zm0,0"
                      transform="translate(-137.898 -110.378)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_96"
                      data-name="Path 96"
                      d="M59.934,34.373A18.783,18.783,0,0,0,38.287,64.785a1.106,1.106,0,1,0,1.477-1.645,16.573,16.573,0,0,1,19.1-26.832,1.106,1.106,0,0,0,1.071-1.935Zm0,0"
                      transform="translate(-27.582 -27.601)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_97"
                      data-name="Path 97"
                      d="M65.156,424.07a1.106,1.106,0,1,0,0,2.211H71.79a1.106,1.106,0,1,0,0-2.211Zm0,0"
                      transform="translate(-55.166 -365.472)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_98"
                      data-name="Path 98"
                      d="M51.692,255.525H39.53V241.152a1.105,1.105,0,0,0-2.065-.553l-8.527,14.926h-1.57a3.317,3.317,0,0,0-3.317,3.317V269.9a3.317,3.317,0,0,0,3.317,3.317H51.692a3.317,3.317,0,0,0,3.317-3.317v-2.211a1.106,1.106,0,1,0-2.211,0V269.9A1.106,1.106,0,0,1,51.692,271H27.368a1.106,1.106,0,0,1-1.106-1.106V258.842a1.106,1.106,0,0,1,1.106-1.106h2.211a1.106,1.106,0,0,0,.96-.553l6.779-11.868V256.63a1.106,1.106,0,0,0,1.106,1.106H51.692a1.106,1.106,0,0,1,1.106,1.106v2.211a1.106,1.106,0,0,0,2.211,0v-2.211A3.317,3.317,0,0,0,51.692,255.525Zm0,0"
                      transform="translate(-20.694 -206.877)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_99"
                      data-name="Path 99"
                      d="M90,393.176A1.106,1.106,0,0,0,88.9,392.07H81.157a1.106,1.106,0,1,0,0,2.211H88.9A1.106,1.106,0,0,0,90,393.176Zm0,0"
                      transform="translate(-68.955 -337.894)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_100"
                      data-name="Path 100"
                      d="M174.685,393.176a1.106,1.106,0,0,0-1.106-1.106h-4.423a1.106,1.106,0,1,0,0,2.211h4.423A1.106,1.106,0,0,0,174.685,393.176Zm0,0"
                      transform="translate(-144.793 -337.894)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_101"
                      data-name="Path 101"
                      d="M145.157,426.281h4.422a1.106,1.106,0,0,0,0-2.211h-4.422a1.106,1.106,0,1,0,0,2.211Zm0,0"
                      transform="translate(-124.11 -365.472)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_102"
                      data-name="Path 102"
                      d="M345.157,50.282h9.951a1.106,1.106,0,1,0,0-2.211h-9.951a1.106,1.106,0,0,0,0,2.211Zm0,0"
                      transform="translate(-296.469 -41.436)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_103"
                      data-name="Path 103"
                      d="M345.157,90.281h9.951a1.106,1.106,0,0,0,0-2.211h-9.951a1.106,1.106,0,0,0,0,2.211Zm0,0"
                      transform="translate(-296.469 -75.908)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_104"
                      data-name="Path 104"
                      d="M382.685,128.07h-5.528a1.106,1.106,0,1,0,0,2.211h5.528a1.106,1.106,0,0,0,0-2.211Zm0,0"
                      transform="translate(-324.047 -110.38)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_105"
                      data-name="Path 105"
                      d="M382.685,168.07h-5.528a1.106,1.106,0,0,0,0,2.211h5.528a1.106,1.106,0,0,0,0-2.211Zm0,0"
                      transform="translate(-324.047 -144.851)"
                      fill="currentColor"
                    />
                    <path
                      id="Path_106"
                      data-name="Path 106"
                      d="M361.157,204.493a1.106,1.106,0,1,0,0,2.211h6.634A2.211,2.211,0,0,0,370,204.493v-2.211a2.211,2.211,0,0,0-2.211-2.211h-6.634a1.106,1.106,0,1,0,0,2.211h6.634v2.211Zm0,0"
                      transform="translate(-310.258 -172.429)"
                      fill="currentColor"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div className="services-card-content-heading">Web SEO</div>
            <div className="services-card-content-pattren">
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
              <div className="services-card-content-pattren-child"></div>
            </div>
            <div className="services-card-content-detail">
              SEO is the process of taking steps to help a website or piece of
              content rank higher on Google. ... To make it a bit simpler,
              search engine optimization means taking a piece of online content
              and optimizing it so search engines like Google show it towards
              the top of the page when someone searches for something.
            </div>
            <a
              href="https://www.google.com/search?q=what+is+Web+SEO&sxsrf=AOaemvIsnf0y9fLjPOQo1Nhpl8urqqT7sg%3A1638905119934&ei=H7WvYefCOMKTxc8PuM28qAQ&ved=0ahUKEwinzvmrtdL0AhXCSfEDHbgmD0UQ4dUDCA4&uact=5&oq=what+is+Web+SEO&gs_lcp=Cgdnd3Mtd2l6EAMyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEcyBAgAEEdKBAhBGABQtAVY-QhgkgtoAHACeACAAQCIAQCSAQCYAQCgAQGgAQLIAQjAAQE&sclient=gws-wiz"
              title="learn-more"
              className="services-card-content-link"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 14.75 10.372"
              >
                <path
                  id="arrow"
                  d="M9.933,4.83a.523.523,0,0,0-.743.736l3.769,3.769H.52A.518.518,0,0,0,0,9.856a.524.524,0,0,0,.52.528H12.959L9.189,14.146a.534.534,0,0,0,0,.743.521.521,0,0,0,.743,0l4.662-4.662a.512.512,0,0,0,0-.736Z"
                  transform="translate(0 -4.674)"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
